import { MedicineBoxOutlined } from "@ant-design/icons";
import { ResourceProps } from "@refinedev/core";

export const medicineResource: ResourceProps = {
  name: "medicine",
  meta: {
    icon: <MedicineBoxOutlined />,
    label: "Медицина",
  },
  list: "/medicine",
};
